import styled from '@emotion/styled';
import { withRouter } from 'react-router-dom';

const CustomLink = styled.a(({ theme, header, tab, isActive }) => {
    let typography = header ? theme.typography.h5 : theme.typography.p;
    let padding = tab ? {
        padding: `${theme.spacing.xs} ${theme.spacing.s}`
    } : {};

    return {
        ...typography,
        color: isActive() ? theme.colors.primary.main : theme.colors.common.white,
        borderBottom: isActive() ? `solid ${theme.colors.primary.main} 3px` : 'none',
        textDecoration: 'none',
        opacity: 1,
        '&:hover': {
            color: theme.colors.primary.main,
            cursor: 'pointer'
        },
        ...padding
    };
});

function StyledLink({ href, children, header, tab, activeWhen, onClick, match, history, location, style }) {
    function isActive() {
        if (href) {
            return location.pathname.includes(href.slice(2));
        }
    }

    return (
        <CustomLink href={href} header={header} tab={tab} isActive={isActive} onClick={onClick}>{children}</CustomLink>
    );
}

export default withRouter(StyledLink);
